import {
  UPDATE_EXPENSE_START,
  UPDATE_EXPENSE_SUCCESS,
  UPDATE_EXPENSE_FAILURE,
  PRIMARY_ENTERS_DATA_CHANGED,
} from './types';

export const primaryEntersDataChanged = (payload) => ({
  type: PRIMARY_ENTERS_DATA_CHANGED,
  payload: payload,
})

export const updateExpenseStart = (payload) => ({
  type: UPDATE_EXPENSE_START,
  payload: payload,
})

export const updateExpenseSuccess = (payload) => ({
  type: UPDATE_EXPENSE_SUCCESS,
  payload: payload,
})

export const updateExpenseFailure = (payload) => ({
  type: UPDATE_EXPENSE_FAILURE,
  payload: payload,
})
